exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._2xFKnSjnlUw-74oVB_FFiq{text-align:center;position:relative;box-sizing:border-box;position:fixed;top:55%;left:50%}\n", ""]);

// exports
exports.locals = {
	"loading-spinner": "_2xFKnSjnlUw-74oVB_FFiq",
	"loadingSpinner": "_2xFKnSjnlUw-74oVB_FFiq"
};